import { useState } from "react";
import { Button, Form } from "react-bootstrap";
import { SpeedReport } from "../../../Api/reportingApi";

export const SpeedsReporting = () => {
    const [startDate, setStartDate] = useState();
    const [endDate, setEndDate] = useState();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");

    const handleSubmit = (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        console.log(startDate, endDate);

        SpeedReport(startDate, endDate).then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));

            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'speed-report.csv'); 
            document.body.appendChild(link);
            link.click();
            link.remove();

            window.URL.revokeObjectURL(url);

            setLoading(false);
        }).catch((error) => {
            setError(error);
            console.error(error);
        });
    };

    return <>
        <h1>Speed Reporting</h1>
        <p>This report provides anonymous location and speed data.</p>
        <Form>
            <Form.Group controlId="startDate">
                <Form.Label>Start Date</Form.Label>
                <Form.Control
                    type="date"
                    value={startDate}
                    onChange={(e) => {
                        setStartDate(e.target.value);
                    }}
                />
            </Form.Group>
            <Form.Group controlId="endDate">
                <Form.Label>End Date</Form.Label>
                <Form.Control
                    type="date"
                    value={endDate}
                    onChange={(e) => {
                        setEndDate(e.target.value);
                    }}
                />
            </Form.Group>
            <br />
            <Button
                variant="primary"
                type="submit"
                onClick={handleSubmit}
                disabled={loading}
            >
                {loading && (
                    <span
                        className="spinner-border spinner-border-sm"
                        role="status"
                        aria-hidden="true"
                    ></span>
                )}
                {!loading && "Submit"}
            </Button>
        </Form>
    </>
}